const Yup = require('./yup')

const createFieldType = function (fieldType, fieldAlias, hasRequired, hasMin, hasMax, hasJustify, hasSelectOptions) {
  return {
    fieldType,
    fieldAlias,
    hasRequired,
    hasMin,
    hasMax,
    hasJustify,
    hasSelectOptions
  }
}

const fieldTypes = [
  createFieldType('TEXT', 'Texto', true, true, true, true, false),
  createFieldType('LONGTEXT', 'Texto Longo', true, false, false, false, false),
  createFieldType('LABEL', 'Rótulo', false, false, false, false, false),
  createFieldType('SESSION', 'Sessão', false, false, false, false, false),
  createFieldType('DATE', 'Data', true, false, false, true, false),
  createFieldType('INTEGER', 'Inteiro',true, true, true, true, false),
  createFieldType('DECIMAL', 'Decimal', true, true, true, true, false),
  createFieldType('BOOLEAN', 'Sim/Não', false, false, false, true, false),
  createFieldType('SELECT', 'Seleção Simples', true, false, false, false, true),
  createFieldType('IMAGE', 'Imagem', true, false, false, false, false),
  createFieldType('IMAGE_LIST', 'Multiplas imagens', true, true, true, false, false),
]

function translateType(type) {
  switch (type) {
    case 'TEXT': 
      return 'string'
    case 'LONGTEXT': 
      return 'string'
    case 'DATE': 
      return 'date'
    case 'INTEGER': 
      return 'integer'
    case 'DECIMAL': 
      return 'number'
    case 'BOOLEAN': 
      return 'boolean'
    case 'SELECT': 
      return 'string'
    case 'IMAGE': 
      return 'image_shape'
    case 'IMAGE_LIST': 
      return 'image_shape_array'
  }
}

function getChecklistSchema(items) {
  if (!Array.isArray(items)) {
    return undefined;
  }

  const properties = {}
  const errMessages = {}

  for (const item of items) {
    properties[`${item.id}`] = {};
    errMessages[`${item.id}`] = {};

    properties[`${item.id}`].type = translateType(item.fieldType);
    properties[`${item.id}`].description = item.fieldName;

    const fieldType = fieldTypes.find(elem => elem.fieldType === item.fieldType);
    if (fieldType) {
      if (fieldType.hasRequired) {
        properties[`${item.id}`].required = item.required;
        errMessages[`${item.id}`].required = `O campo '${item.fieldName}' é obrigatório`;
      }
      if (fieldType.hasMin && (item.min !== null && item.min !== undefined)) {
        if (fieldType.fieldType === 'TEXT') {
          properties[`${item.id}`].min = item.min;
          errMessages[`${item.id}`].min = `O campo '${item.fieldName}' precisa de no minimo ${item.min} caracteres.`;
        } else {
          properties[`${item.id}`].min = item.min;
          errMessages[`${item.id}`].min = `O campo '${item.fieldName}' precisa ser no minimo ${item.min}`;
        }
      }
      if (fieldType.hasMax && (item.max !== null && item.max !== undefined)) {
        if (fieldType.fieldType === 'TEXT') {
          properties[`${item.id}`].max = item.max;
          errMessages[`${item.id}`].max = `O campo '${item.fieldName}' precisa de no máximo ${item.max} caracteres.`;
        } else {
          properties[`${item.id}`].max = item.max;
          errMessages[`${item.id}`].max = `O campo '${item.fieldName}' precisa ser no máximo ${item.max}`;
        }
      }
      if (fieldType.hasSelectOptions) {
        if (item.selectOptions && Array.isArray(item.selectOptions)) {
          properties[`${item.id}`].oneOf = item.selectOptions.map(elem => elem.option);
        }
      }
    }
  }

  const object = {
    body: {
      type: "object",
      properties
    },
    config: {
      errMessages
    }
  }

  return object;
}

/*premixSchemaToYup */
function createValidateField(itemName, item, errMsg) {
  switch (item.type) {
    case 'string': 
      return createStringType(itemName, item, errMsg);
    case 'date': 
      return createDateType(itemName, item, errMsg);
    case 'integer': 
      return createIntegerType(itemName, item, errMsg);
    case 'number': 
      return createNumberType(itemName, item, errMsg);
    case 'boolean': 
      return createBooleanType(itemName, item, errMsg);
    case 'image_shape': 
      return createImageShapeType(itemName, item, errMsg);
    case 'image_shape_array': 
      return createImageShapeArrayType(itemName, item, errMsg);
    default:
      return undefined;
  }
}

function incrementObject(obj, item, errMsg) {
  let objReturn = obj;
  if (item.required) {
    objReturn = objReturn.required(errMsg.required);
  } else {
    objReturn = objReturn.nullable();
  }

  if (item.min !== null && item.min !== undefined) {
    objReturn = objReturn.min(item.min, errMsg.min);
  }
  if (item.max !== null && item.max !== undefined) {
    objReturn = objReturn.max(item.max, errMsg.max);
  }

  if (item.oneOf && Array.isArray(item.oneOf)) {
    objReturn = objReturn.oneOf(item.oneOf);
  }

  return objReturn;
}

function createStringType(itemName, item, errMsg) {
  let obj = Yup.string().typeError(`O campo '${item.description}' não é do tipo texto`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createIntegerType(itemName, item, errMsg) {
  let obj = Yup.number().integer().typeError(`O campo '${item.description}' não é do tipo inteiro`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createNumberType(itemName, item, errMsg) {
  let obj = Yup.number().typeError(`O campo '${item.description}' não é do tipo numero`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createBooleanType(itemName, item, errMsg) {
  let obj = Yup.boolean().typeError(`O campo '${item.description}' não é do tipo sim/não`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createDateType(itemName, item, errMsg) {
  let obj = Yup.date().typeError(`O campo '${item.description}' não é do tipo data`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createImageShapeType(itemName, item, errMsg) {
  let obj = Yup.object().shape({
    id: Yup.number().integer().required('O campo Id da imagem é obrigatório.'),
    uuid: Yup.string().uuid('O campo UUID da imagem não é válido').required('O campo UUID da imagem é obrigatório.'),
  }).typeError(`O campo '${item.description}' não é do tipo imagem`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function createImageShapeArrayType(itemName, item, errMsg) {
  let obj = Yup.array().of(
    Yup.object().shape({
      id: Yup.number().integer().required('O campo Id da imagem é obrigatório.'),
      uuid: Yup.string().uuid('O campo UUID da imagem não é válido').required('O campo UUID da imagem é obrigatório.'),
    })
  ).typeError(`O campo '${item.description}' não é do tipo imagens`);

  obj = incrementObject(obj, item, errMsg);

  return obj
}

function getYupSchema(checklistSchema) {
  if (!checklistSchema || !checklistSchema.body) {
    return undefined;
  }
  
  const objectSchema = {}

  for (const item in checklistSchema.body.properties) {
    let checklistItem = checklistSchema.body.properties[item];
    let checklistErrMsg = checklistSchema.config ? checklistSchema.config.errMessages[item] : undefined;

    let tempObject = createValidateField(item, checklistItem, checklistErrMsg);
      
    objectSchema[item] = tempObject;
  }

  return Yup.object().shape(objectSchema);
}

async function validateChecklist(data, schema) {
  let errors = []
  try { 
    await schema.validate(data, {
      abortEarly: false,
    });

    data = await schema.validateSync(data);
    return [];
  } catch (err) {
    const validationErrors = {};
    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach(error => {
        validationErrors[error.path] = error.message;
        errors = [...errors, {
          field: error.path,
          message: error.message
        }]
        console.log(error)
      });
    }
    return errors;
  }
}

function sanitizeFieldValue(fieldType, value) {
  const type = translateType(fieldType);
  let result;
  
  switch (type) {
    case 'string': 
      result = {
        stringValue: value
      }
      break;
    case 'date': 
      result = {
        dateValue: value
      }
      break;
    case 'integer': 
      result = {
        integerValue: value
      }
      break;
    case 'number': 
      result = {
        floatValue: value
      }
      break;
    case 'boolean': 
      result = {
        boolValue: value
      }
      break;
  }

  return result;
}

function getDbFieldValue(fieldType, register) {
  const type = translateType(fieldType);
  
  switch (type) {
    case 'string': 
      return register.stringValue;
    case 'date': 
      return register.dateValue;
    case 'integer': 
      return register.integerValue;
    case 'number': 
      return register.floatValue;
    case 'boolean': 
      return register.boolValue;
  }
}

module.exports = {
  getDbFieldValue,
  sanitizeFieldValue,
  validateChecklist,
  getYupSchema,
  getChecklistSchema,
  fieldTypes
}